<template>
  <div style="height: 100%;" >
    <el-container style="height: 100%;" >
      <el-aside width="auto"   style="overflow-y: auto;" >
        <div v-if="currentUser" style="background-color:#545c64;color: #fff; padding-top:10px;text-align:center" class="el-menu-demo el-menu">          
           <el-button  icon="el-icon-more" circle @click="clickCollapse" ></el-button>
        </div>
        <el-menu v-if="currentUser" :default-active="activeIndex2" class="el-menu-demo" @select="handleSelect"  
          background-color="#545c64"  text-color="#fff"  active-text-color="#ffd04b" router :collapse="isCollapse" style="height: 95%;">
          <el-menu-item index="/home">
            <i class="el-icon-s-home"></i>
            <span slot="title">{{ $t('menu.home')}}</span>
          </el-menu-item>  
          <el-submenu :index="index+''" v-for="(item,index) in menuData" v-if="item.children != null" :key="index">
            <template slot="title">    
               <i :class="item.iconcls"></i>
              <span>{{ $t(item.name) }}</span>
            </template>
            <el-menu-item :index="child.path" v-for="(child, indexj) in item.children" :key="indexj" >
              {{ $t(child.name) }}
            </el-menu-item>
          </el-submenu>
          <el-menu-item :index="item.path" v-else :key="index">
             <i :class="item.iconcls"></i>
            <span slot="title">{{ $t(item.name) }}</span>
          </el-menu-item>
          <el-submenu index="888">
            <template slot="title">
              <i class="el-icon-chat-dot-round"></i>
              <span slot="title">{{ $t('menu.language')}}</span>
            </template>
            <el-menu-item @click="changeTw">中文</el-menu-item>
            <el-menu-item @click="changeEn">English</el-menu-item>    
          </el-submenu>        
          <!--<el-menu-item v-if="!currentUser"  index="/register">{{ $t('signUp')}}</el-menu-item>
          <el-menu-item v-if="!currentUser"  index="/login">{{ $t('login')}}</el-menu-item>    
          <el-menu-item v-if="currentUser"  @click="logOut">{{ $t('logout')}}</el-menu-item> -->  
        </el-menu>
      </el-aside>
      <el-container style="height: 100%;">
        <el-header v-if="currentUser" style="font-size: 14px" >
          Hi {{ currentUser.nickname }} 
          <el-link  @click="logOut"> {{ $t('logout')}}</el-link>
        </el-header>
        <el-main><router-view></router-view></el-main>
        <el-footer>Copyright 2022 InnoCare Corporation    v1.1.1</el-footer>
      </el-container>
    </el-container>
  </div>
</template>

<style scoped>
.el-menu--horizontal > .el-menu-item.dock-right {
  float: right !important; 
}
.el-menu--horizontal > .el-submenu.dock-right {
  float: right !important; 
}
.el-header {   
  padding-top:10px;
  padding-right:100px;
  text-align:right;
  height:30px !important;
}
.el-aside {
  overflow: hidden
}
.el-main {
  padding:10px;

}
.el-footer {   
    font-size:12px;
    text-align:right;
    height:30px !important;
}
  
body > .el-container {
  margin-bottom: 40px;
}

.el-menu--horizontal > .el-submenu.dock-right {
  float: right !important; 
}

/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey; 
  border-radius: 10px;
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: grey; 
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: grey;
}
</style>
<script>
import { apiMenuSearch } from "./utils/api.js";
import authHeader from "./services/auth-header";

export default {
  data() {
    var menuDefault = false;
    if(this.$store.state.auth.user!=null && this.$store.state.auth.user.username.indexOf('@') > -1){
      menuDefault = true;
    }    
    // username: "grace.chiou"  
    return {
      isCollapse: menuDefault,
      activeIndex2: "1",
      menuData: this.$store.state.routes,
      optionsLang: [
        { text: '中文', value: 'tw' },
        { text: 'English', value: 'en' }
      ]
    };
  }, 
  mounted() {    
    if( this.$store.state.auth.user == null ){
      this.$router.push("/login");
    }else{
      if ( this.$store.state == null || this.$store.state.routes == null || this.$store.state.routes.length < 2 ) {
        apiMenuSearch({ headers: authHeader() }).then((response) => {   
          if (response.data) {
            let fmtRoutes = this.formatRoutes(response.data);
            this.$router.addRoutes(fmtRoutes);
            this.$store.commit("initRoutes", fmtRoutes);
          }
          this.menuData = this.$store.state.routes;
          if(this.menuData.length < 2){
            this.isCollapse = true;
          }
          
        })
        .catch((err) => {
          console.log(err);
        });
      }   
    }
  },
  computed: {
    /*  */
    currentUser() {
      return this.$store.state.auth.user;
    },
    showAdminBoard() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes("ROLE_ADMIN");
      }

      return false;
    },
    showModeratorBoard() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes("ROLE_MODERATOR");
      }

      return false;
    }
  },
  watch: {
    // 檢測路由變化
    $route() {
      this.setCurrentRoute();
    },
  },
  methods: {
    logOut() {
      this.$store.dispatch("auth/logout");
      this.$router.push("/login");
      this.menuData = null;
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    formatRoutes(routes) {
      let fmRoutes = [];
      routes.forEach((router) => {
        let { path, name, meta, iconcls, children } = router;
        if (children && children instanceof Array) {
          children = this.formatRoutes(children);
        }
        let fmRouter = {
          path: path,
          name: name,
          iconcls: iconcls,
          children: children
        };
        fmRoutes.push(fmRouter);
      });
      return fmRoutes;
    },
    setCurrentRoute() {
      this.activeIndex = this.$route.path; // 通过他就可以监听到当前路由状态并激活当前菜单
    },
    // 儲存切換的語系
    setLang (value) {
      this.$store.commit('setLang', value);
      this.$i18n.locale = value;
      localStorage.setItem('footmark-lang', value);      
      location.reload();
    },
    changeTw(){
      this.setLang ('tw');
    },
    changeEn(){
      this.setLang ('en');
    },
    handleOpen(key, keyPath) {
        console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath);
      },
      clickCollapse(){
        this.isCollapse = !this.isCollapse;
      }
  },
};
</script>
